module.exports = __webpack_public_path__ + "img/watch-logo.d585ec7a.png";